import { MetadataContent } from '@jutro/legacy/uiconfig';
import { React, useContext, useEffect, useState, useCallback } from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { IntlContext } from '@jutro/locale';
import { LoaderExt } from 'gw-components-platform-react';
import { PayrollReportingTable } from 'cpmi-capability-payrollreporting-react';
import { withRouter } from 'react-router-dom';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import moment from 'moment';
import _ from 'lodash';
import PolicyService from '../../../../common/capabilities/gw-capability-policy/services/PolicyService';
import PayrollService from '../../../../common/capabilities/cpmi-capability-payroll/services/PayrollService';
import styles from './PayrollReportingPage.module.scss';
import metadata from './PayrollReportingPage.metadata.json5';
import './PayrollReportingPage.messages';
import PayrollDocumentsTable from './PayrollDocumentsTable/PayrollDocumentsTable';
import usecpmiAnalytics from '../../hooks/usecpmiAnalytics'
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';
import { AccountDropDownValues } from "../cpmi_SelectAccountDropDown";
// eslint-disable-next-line import/no-cycle, import/named

// import { UserContext } from './context';


function PayrollReportingPage(props) {

    const { authHeader } = useAuthentication();
    const [policysummary, setPolicysummary] = useState([]);
    const [reportingData, setReportingData] = useState([]);
    const [selectedPolicy, setSelectedPolicy] = useState(' ');
    const [termNumber, setTermNumber] = useState(' ');
    const [PayrollDocument, setPayrollDocument] = useState([]);
    const [filteredPayrollReport, setfilteredPayrollReport] = useState([]);
    const [SelectedPolicyperoid, setSelectedPolicyperoid] = useState(null);
    const [policystatus, setPolicyStatus] = useState('');
    const [trackPageView, trackEvent] = usecpmiAnalytics();
    const [policyPeriodData, setPolicyPeriodData] = useState([])
    const [isLoadingData, updateIsLoadingData] = useState(false);
    const [policyPeriodTermPeriod, setPolicyPeriodTermPeriod] = useState(null)
    const [trackGAPageView] = useGoogleAnalytics();
    const { refreshData } = useDataRefresh();
    const intl = useContext(IntlContext);
    const [successMessageShowHide, setSuccessMessageShowHide] = useState(true);
    const [policyAccountDropdown, setPolicyAccountDropdown] = useState(null);
    const [defaultSelectedPolicy, setDefaultSelectedPolicy] = useState();
    const [allDataSet, setAllDataSet] = useState([]);
    // const user = useContext(UserContext);
    const [filterAccountCount, setFilterAccountCount] = useState();
    const [lineOfBusinessCodeValue, setLineOfBusinessCodeValue] = useState('');
    const [payrollLoading, setPayrollLoading] = useState(false)

    useEffect(() => {
        getPolicyPeroiddropdown(selectedPolicy);
    }, [policysummary, selectedPolicy])

    useEffect(() => {
        trackPageView("Payroll Reporting", "/payroll-reporting/list/report");
    }, [])

    const getPolicies = useCallback(() => {
        if (policysummary.length === 0) {
            return []
        }
        let policies = [];
        policysummary.forEach((policy) => {
            const obj = {
                code: policy.policyNumber,
                name: `${policy.policyNumber} ${policy.primaryStates[0]}`,
                termNumber: policy.termNumber,
            };
            policies.push(obj);
        });

        policies = policies.filter(
            (value, index, self) =>
                index ===
                self.findIndex(
                    (t) => t.code === value.code && t.name === value.name
                )
        );
        return policies;
    }, [policysummary]);

    const handleValueChange1 = (value) => {
        setPolicyAccountDropdown(value);
    }

    const handlePolicyChange = useCallback(
        (response) => {
            setSelectedPolicy(response);
            const termdata = policysummary.filter((i) => {
                return i.policyNumber === response;
            });
            setPolicyStatus(termdata[0].displayStatus);
            setTermNumber(termdata[0].termNumber);
        },
        [policysummary]
    );



    const getPolicySummaries = useCallback(async () => {
        updateIsLoadingData(true);
        await PolicyService.getAccountPolicySummariesForPayroll(
            authHeader
        ).then((result) => {
            if (result.length === 0) {

                setPolicysummary(result);
                setAllDataSet(result);
                return;

            }

            setAllDataSet(result);
            setSelectedPolicy(result[0].policyNumber);
            setTermNumber(result[0].termNumber);
            setPolicyStatus(result[0].displayStatus);

            setPolicysummary(result);
        }).finally(() => {
            updateIsLoadingData(false);
        });
    }, [authHeader]);

    useEffect(() => {
        if (policyAccountDropdown) {
            const policysummaryAccountFilter = allDataSet.filter((filterItem) => {
                return filterItem.accountNumber === policyAccountDropdown
            })
            setFilterAccountCount(policysummaryAccountFilter);
            if (policysummaryAccountFilter?.length !== 0) {
                if (!_.isEqual(policysummary, policysummaryAccountFilter)) {
                    setSelectedPolicy(policysummaryAccountFilter[0]?.policyNumber);
                    setTermNumber(policysummaryAccountFilter[0]?.termNumber);
                    setPolicyStatus(policysummaryAccountFilter[0]?.displayStatus);

                    setPolicysummary(policysummaryAccountFilter);

                }
            }
        }
    }, [allDataSet, policyAccountDropdown, policysummary])

    useEffect(() => {
        if (filterAccountCount?.length === 0) {
            setPolicysummary([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterAccountCount?.length === 0])


    const getPolicyPeroiddropdown = useCallback((policyNumber) => {
        let policyperiod = policysummary.filter((policy) => {
            return policy.policyNumber === policyNumber

        }).
            map((policy) => {
                setLineOfBusinessCodeValue(policy.lineOfBusinessCode);

                const startDate = moment((policy.effective)).format('MM/DD/YYYY');
                const endDate = moment((policy.expiration)).format('MM/DD/YYYY');
                return {
                    code: `${startDate} - ${endDate}`,
                    name: `${startDate} - ${endDate}`,
                    termNumber: policy.termNumber,
                    periodStatus: policy.displayStatus
                };
            });
        policyperiod = policyperiod.filter(
            (value, index, self) =>
                index ===
                self.findIndex(
                    (t) => t.code === value.code && t.name === value.name
                )
        );
        setPolicyPeriodData(policyperiod);
        setSelectedPolicyperoid(policyperiod[0]);
        if (policyperiod[0] !== undefined) {
            setPolicyPeriodTermPeriod(policyperiod[0].code);
        }

        return policyperiod;
    }, [policysummary]);


    const handlePolicytermselection = (value) => {
        setSelectedPolicyperoid(value);

        const res = policyPeriodData.filter((item) => { return item.code === value });

        setTermNumber(res[0].termNumber);
        setPolicyStatus(res[0].periodStatus)

    };

    useEffect(() => {
        getPolicySummaries();
    }, []);

    useEffect(() => {
        trackGAPageView("/payroll-reporting/list/report", "Payroll Reporting")
    }, [])

    useEffect(() => {

        const data = [selectedPolicy, termNumber];

        if (selectedPolicy !== ' ' && termNumber !== ' ' && filterAccountCount?.length !== 0) {
            updateIsLoadingData(true);
            PayrollService.getPremiumReports(data, authHeader).then((res) => {
                setReportingData(res);
                setfilteredPayrollReport(res);
            });

            PayrollService.getPayrollDocuments(data, authHeader).then((res) => {
                setPayrollDocument(res);
            }).finally(() => {
                updateIsLoadingData(false);
            });

        }
    }, [authHeader, policyPeriodData, selectedPolicy, termNumber, refreshData, filterAccountCount?.length]);

    const displayNotification = () => {
        if (window.location.href.indexOf('selectedTerm') > -1) return true;
        return false;
    };

    const displayPayrollNotification = () => {
        if (window.location.href.indexOf('success') > -1) return true;
        return false;

    }

    const updatePayrollTable = useCallback(() => {
        refreshData();
        setSuccessMessageShowHide(false);
    }, [refreshData])

    if (isLoadingData) {
        return <LoaderExt loaded={!isLoadingData} />;
    }

    const overrides = {

        payrollDocumentsTableId: {
            payrollData: PayrollDocument
        },
        notification1: {
            visible: policysummary.length === 0 || filterAccountCount?.length === 0

        },
        payrollreportsTableId: {
            payrollData: filteredPayrollReport,
            appValue: 'CE',
            termperiod: policyPeriodTermPeriod,
            policyStatus: policystatus,
            updatePayrollTable,
            lineOfBusinessCodeValue,
            payrollLoading,
            updatePayrollVoidLoading: setPayrollLoading
        },
        PolicyFilterDropDown: {
            availableValues: getPolicies(policysummary),
            onValueChange: handlePolicyChange,
            value: selectedPolicy,
        },
        PolicytermFilter: {
            // availableValues: getPolicyPeroiddropdown(),
            availableValues: policyPeriodData,
            onValueChange: handlePolicytermselection,
            value: SelectedPolicyperoid,
        },
        payrollStatus: {
            value: policystatus,
        },
        notification: {
            visible: displayNotification(),
        },
        payrollNotification: {
            visible: successMessageShowHide && displayPayrollNotification()
        },
        payrollContainer: {
            visible: policysummary.length !== 0 && filterAccountCount?.length !== 0
        },
        pageTitleHorizontalLine: {
            visible: !(props?.history?.location?.state?.page === "LandingPage" && policyAccountDropdown === null)
        },
        payrollDetailsContainerId: {
            visible: !(props?.history?.location?.state?.page === "LandingPage" && policyAccountDropdown === null)
        },
        availableProducerCode: {
            removeSelected: props?.history?.location?.state?.page === "LandingPage" && (policyAccountDropdown === null)
        },

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            PayrollDocumentsTable: PayrollDocumentsTable,
            PayrollReportingTable: PayrollReportingTable,
            AccountDropDownValues: AccountDropDownValues,
        },
        resolveCallbackMap: {
            handleValueChange: handleValueChange1
        },
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
}

export default withRouter(PayrollReportingPage);
